export default __webpack_public_path__ + "static/media/yesword.96d385d4.PNG";